module.exports = __webpack_public_path__ + "img/logo_investorid.b58bf136.png";